module.exports = __webpack_public_path__ + "img/04-top-img@2x.ca99465e.png";